import { Injectable } from '@angular/core';
import {
  IIcLookupUnionDataDto,
  IcLookupDto,
  IcLookupTypeEnumDto,
  IcLookupUnionItemDto,
} from '@data-access/bulk-operations-api';

import { IcServiceBase } from './ic-service.base';

@Injectable({ providedIn: 'root' })
export class IcUnionsService extends IcServiceBase<IcLookupUnionItemDto, IcUnion> {
  protected override lookupType = IcLookupTypeEnumDto.Union;

  protected override mapToLookupModel(value: IcLookupUnionItemDto): IcUnion {
    return {
      ...value.data,
      id: value.id,
      displayName: value.data.name,
    };
  }

  protected override getValuesFromLookupDto(lookup: IcLookupDto): IcLookupUnionItemDto[] {
    return lookup.unions;
  }
}

export type IcUnion = IIcLookupUnionDataDto & { id: string; displayName: string };
